const mapContext = context => {
  const { storeCode, language, ...rest } = context;
  return { store: storeCode, lang: language, ...rest };
};

export default mapContext;
